import { INITIAL_RENDER, NAVIGATED_TO_ZTSS, SET_COOKIE_RESPONSE } from '../constants/actions';

const initState = {
  ip: '',
  hostname: null,
  brand: 'hotpads',
  apiResponseServerSideRequestCookies: [],
  isInWebView: false,
  isMobile: false,
  csrfToken: '',
  zgApi: '',
  rentalPrefixUrl: '',
  zgBaseUrl: '',
  zgEnv: '',
  zgGraphUri: '',
  isZtss: false,
};

export default function appReducer(state = initState, action) {
  switch (action.type) {
    case INITIAL_RENDER: {
      const {
        hostname,
        brand,
        apiResponseServerSideRequestCookies,
        ip,
        isInWebView,
        isMobile,
        zgApi,
        rentalPrefixUrl,
        zgBaseUrl,
        zgEnv,
        csrfToken,
        zgGraphUri,
      } = action;
      return {
        ...state,
        ip,
        hostname,
        brand,
        apiResponseServerSideRequestCookies,
        isInWebView,
        isMobile,
        zgBaseUrl,
        zgApi,
        rentalPrefixUrl,
        zgEnv,
        csrfToken,
        zgGraphUri,
      };
    }
    case SET_COOKIE_RESPONSE:
      return {
        ...state,
        apiResponseServerSideRequestCookies: action.header,
      };

    case NAVIGATED_TO_ZTSS:
      return {
        ...state,
        isZtss: true,
      };
    default:
      return state;
  }
}
